import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import {colors} from 'styles/shared';

const LinkDiv = styled(Link)`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};

  span {
    color: ${colors.blue_darker};
  }
`;

AuthLink.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired
};

function AuthLink({url, title, linkText}) {
  return (
    <LinkDiv to={url}>
      {title} <span>{linkText}</span>
    </LinkDiv>
  );
}

export default AuthLink;
